import { z } from 'zod';

/////////////////////////////////////////
// PERMITS EXTENSION DEFINITIONS SCHEMA
/////////////////////////////////////////

export const PermitsExtensionDefinitionsSchema = z.object({
  id: z.bigint(),
  cityId: z.number().int().nullable(),
  fieldName: z.string().nullable(),
  key: z.string().nullable(),
  fieldDescription: z.string().nullable(),
  fieldType: z.number().int().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  fieldOptions: z.string().nullable(),
  fieldDefaultValue: z.string().nullable(),
  deactivated_at: z.coerce.date().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type PermitsExtensionDefinitions = z.infer<typeof PermitsExtensionDefinitionsSchema>

export default PermitsExtensionDefinitionsSchema;
